import { intlFormat } from "date-fns";

export default {
    formatDate(date) {
        return intlFormat(new Date(date), { weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" });
    },
}